import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TribunalCaseType, tribunalCaseTypesByCountry, } from '@debbie/common/dist/tribunal/cases/types.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import Select from '../../Select.js';
import Well from '../../Well.js';
import { Betalingspaakrav, Fogedrekvisition, GLBetalingspaakrav, } from './types/index.js';
import Fogedbegaering from './types/Fogedbegaering.js';
import Staevning from './types/Staevning.js';
const CreateTribunalCase = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const caseTypes = tenant
        ? // @ts-ignore
            tribunalCaseTypesByCountry[tenant.countryCode]
        : null;
    const [type, setType] = useState(null);
    useEffect(() => {
        if (caseTypes) {
            // @ts-ignore
            const caseType = Object.values(caseTypes);
            if (caseType[0]) {
                // @ts-ignore
                setType(caseType[0]);
            }
        }
    }, [caseTypes]);
    if (!tenant)
        return null;
    return (React.createElement("div", null,
        React.createElement(Select, { value: type, onChange: (e) => setType(e.target.value) }, 
        // @ts-ignore
        Object.values(caseTypes).map((t) => (React.createElement("option", { key: t, value: t }, 
        // @ts-ignore
        lang.tribunalCaseTypes[t])))),
        React.createElement(Well, null,
            type === TribunalCaseType.DKBetalingspaakrav && (React.createElement(Betalingspaakrav, { caseSeqId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated })),
            type === TribunalCaseType.DKFogedrekvisition && (React.createElement(Fogedrekvisition, { caseSeqId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated })),
            type === TribunalCaseType.GLStaevning && (React.createElement(React.Fragment, null,
                React.createElement(Staevning, { caseSequentialId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated }))),
            type === TribunalCaseType.GLFogedBegaering && (React.createElement(React.Fragment, null,
                React.createElement(Fogedbegaering, { caseSequentialId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated }))),
            type === TribunalCaseType.GLBetalingspaakrav && (React.createElement(GLBetalingspaakrav, { caseSeqId: props.caseSeqId, tenantId: props.tenantId, onCreated: props.onCreated })))));
};
export default CreateTribunalCase;
//# sourceMappingURL=CreateTribunalCase.js.map